import { Box, Switch, SwitchProps, Typography } from '@mui/material';

import styles from './StlSwitch.module.css';

const sx = {
  padding: 1,
  width: 50,
  height: 36,
  '& .MuiSwitch-track': {
    borderRadius: 11,
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: 'var(--secondary-light-text)',
    boxShadow: 'none',
    width: 14,
    height: 13,
    m: '2.8px',
    '&::before': {
      left: 12,
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 10,
      height: 10,
      margin: '0 2px',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="10" width="10" viewBox="0 0 24 24"><path fill="${encodeURIComponent('#5d5d5d')}" d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/></svg>')`,
    },
  },
  '& .Mui-checked': {
    transform: 'translateX(11px) !important',
    '& .MuiSwitch-thumb': {
      backgroundColor: 'var(--gold-col-light)',
    },
    '& .MuiSwitch-thumb:before': {
      margin: '0 1px',
      left: 12,
      width: 12,
      height: 12,
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 24 24"><path fill="${encodeURIComponent('#4d4531')}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,14.17L19.59,5.59L21,7Z"/></svg>')`,
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: 'rgb(240, 207, 127)',
    opacity: 0.25,
  },
};

export default function StlSwitch({
  checked,
  onChange,
  className,
}: SwitchProps) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={className}
      sx={sx}
      size="medium"
    />
  );
}

export function StlSwitchWithLabel({
  checked,
  onChange,
  label,
}: SwitchProps & { label: string }) {
  return (
    <Box className={styles.switchWithLabel}>
      <Typography variant="h4">{label}</Typography>
      <StlSwitch checked={checked} onChange={onChange} />
    </Box>
  );
}
